export enum VerificationType {
  MasterPassword = 0,
  OTP = 1,
  PIN = 2,
  Biometrics = 3,
}
